import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";
import { LoginProvider } from "./APIContext/LoginContext";
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import PrimeReact from "primereact/api";
import { HelmetProvider } from "react-helmet-async";

PrimeReact.ripple = true;
PrimeReact.zIndex = {
  modal: 1100,    
  overlay: 1000,  
  menu: 1000,     
  tooltip: 1100   
};


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <>
    <HelmetProvider>
      <BrowserRouter>
        <LoginProvider>
          <App />
        </LoginProvider>
      </BrowserRouter>
    </HelmetProvider>
  </>
  // </React.StrictMode>
);

reportWebVitals();



